/**
 *
 * @module PluginType enum
 * @desc Plugin type enumeration
 *
 */
export default {
    ADVERTISING: 'ADVERTISING',
    ANALYTICS: 'ANALYTICS',
    COMMUNICATION: 'COMMUNICATION',
};
